/** BTC 地址项 */
export type BtcAddressItem = {
  // Bybit 这边是将地址类型，当作一条链来处理的，这里代码上保持这个做法，虽然奇怪，但是和其它地方保持概念上的统一，以及和后端沟通顺畅。
  chainId: string;
  chainCode: string;
  address: string;
  publicKey: string;
};

/** BTC 链ID */
export enum BtcChainId {
  NATIVE = '999999999',
  /** Taproot */
  TAPROOT = '999999995',
  /** Nested SegWit */
  P2SH = '999999994',
  /** Legacy */
  P2PKH = '999999993',
}

/** BTC 链代码 */
export enum BtcChainCode {
  NATIVE = 'BTC',
  /** Taproot */
  TAPROOT = 'BTC_TAPROOT',
  /** Nested SegWit */
  P2SH = 'BTC_P2SH',
  /** Legacy */
  P2PKH = 'BTC_P2PKH',
}
